/**
 * Customized to remove `div` from `SPECIAL_TAGS`
 */

import { Linkable } from '@/components/blocks/Linkable/modern';
import { Img } from '@/components/blocks/MaterialImage';
import { Button } from '@mui/material';
import { FC } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SPECIAL_TAGS: Record<string, FC<any>> = {
	a: Linkable,
	button: Button,
	img: Img,
};

export { MUI_ELEMENTS, TYPOGRAPHY_TAGS, SKIP_PARSING } from 'presentation/utils/core/parseHTMLTags';
